import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getRoles as fetchRoles } from '../lib/api'
import { RootState } from '../store'
import { arrayToObject } from '../utilities'

type Role = {
  id: string
  name: string
  details: string
  permissions: Array<string>
  system: boolean
  created_at?: Date
  updated_at?: Date
}

type IndexedRoles = {
  [key: string]: Role
}

type RoleState = {
  roles: IndexedRoles
  adminRole: string
  loaded: boolean
  loading: boolean
  error: any
}

const initialState: RoleState = {
  roles: {},
  adminRole: null,
  loaded: false,
  loading: false,
  error: null
}

export const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    loading: state => {
      state.loading = true
    },

    load: (state, { payload }: PayloadAction<IndexedRoles>) => {
      state.roles = payload
      state.loaded = true
      state.loading = false
    },

    loadAdminRole: (state, { payload }: PayloadAction<string>) => {
      state.adminRole = payload
    },

    failed: (state, { payload }: PayloadAction<string>) => {
      state.error = payload
      state.loading = false
      state.loaded = true
    }
  }
})

export default roleSlice.reducer

export const { loading, load, loadAdminRole, failed } = roleSlice.actions

// Asynchronous thunk action
export function getRoles (allowed = false) {
  return async dispatch => {
    try {
      if (!allowed) {
        dispatch(load({}))
        return
      }

      const roles = await fetchRoles()
      const newRoles = arrayToObject(roles) as IndexedRoles
      dispatch(load(newRoles))

      let adminRole = null
      for (const r of Object.values(newRoles) as any) {
        if (r.system) {
          adminRole = r
        }
      }

      dispatch(loadAdminRole(adminRole))
    } catch (error) {
      console.error('Fetch error in RoleSlice', error)
      dispatch(failed(error))
    }
  }
}

export const selectRole = (state: RootState) => state.role
